import type { SettingsLocale } from "@/locales/fr/settings";

import { ELocale } from "@/stores/interface/interface.types";

const locale: Record<ELocale, string> = {
  [ELocale.FR]: "Français",
  [ELocale.EN]: "English",
};

const settingsLocale: SettingsLocale = {
  settings: {
    title: "Settings",
    language: "Language",
    languageHelp: "Let us know which language you're most comfortable using. You can change at any time",
    largeScreen: "Large Screen",
    largeScreenHelp: "Modify layout to use the maximum width available",
    locale,
    fontSize: "Font size",
    fontSizeHelp: "Modify the global font size and the interface size",
  },
};

export default settingsLocale;
